import { BookingRewireDataType } from "../../../../Models/BookingRewireDataType";

interface UserFields {
  name?: string;
  givenName?: string;
  familyName?: string;
  user?: string;
  email?: string;
  site?: string;
}

export const buildUpdateBookingVariables = (
  booking: BookingRewireDataType,
  resizedEntries: Map<string, { end: string }>,
  user: UserFields,
) => {
  const bookingAny = booking as Record<string, unknown>;
  const resolvedBookingId = (bookingAny.bookingId as string) || booking.id;
  const resolvedDateFrom = booking.dateFrom || (bookingAny.start as string);

  const entries = booking.bookingEntries.map((entry) => {
    const resized = resizedEntries.get(entry.id);
    return {
      allDay: entry.allDay ?? false,
      dateFrom: entry.start,
      dateTo: resized ? resized.end : entry.end,
      inventoryId: entry.inventoryId ?? entry.resource,
      bookingEntryId: entry.id,
      remark: entry.remark ?? "",
      commandType: "UPDATE_REQUEST",
    };
  });

  const newDateTo = entries.reduce(
    (max, e) => (e.dateTo > max ? e.dateTo : max),
    entries[0]?.dateTo ?? booking.dateTo,
  );

  const createdByName =
    user?.name ||
    `${user?.givenName ?? ""} ${user?.familyName ?? ""}`.trim() ||
    user?.user ||
    "";

  const hazardousDeclaration = {
    hasHazardousMaterials: booking.hazardousDeclaration?.hasHazardousMaterials ?? false,
    hazardousMaterialsList: booking.hazardousDeclaration?.hazardousMaterialsList ?? "",
  };

  const assistanceDeclaration = {
    requiresAssistance: booking.assistanceDeclaration?.requiresAssistance ?? false,
    assistanceReason: booking.assistanceDeclaration?.assistanceReason ?? "",
  };

  const elnId = {
    name: booking.elnId?.name ?? "",
  };

  const redPandaProjects = booking.redPandaProjects?.length
    ? booking.redPandaProjects.map((project) => ({
        themeNumber: project.themeNumber,
        projectShortName: project.projectShortName,
        projectName: project.projectName,
        projectId: project.projectId,
      }))
    : null;

  const bookedUserIds = (booking.bookedUsers ?? [])
    .map((bookedUser) => bookedUser.user)
    .filter(Boolean);
  const bookedUserEmails = (booking.bookedUsers ?? [])
    .map((bookedUser) => bookedUser.email)
    .filter(Boolean);

  const reservedForUsers =
    (booking.reservedForUsers ?? []).filter(Boolean).length > 0
      ? (booking.reservedForUsers ?? []).filter(Boolean)
      : bookedUserIds.length > 0
        ? bookedUserIds
        : user?.user
          ? [user.user]
          : [];

  const reservedForEmails =
    (booking.reservedForEmails ?? []).filter(Boolean).length > 0
      ? (booking.reservedForEmails ?? []).filter(Boolean)
      : bookedUserEmails.length > 0
        ? bookedUserEmails
        : user?.email
          ? [user.email]
          : [];

  return {
    variables: {
      createdBy: user?.user ?? "",
      createdByEmail: user?.email ?? "",
      createdByName,
      entries,
      type: booking.type,
      bookingId: resolvedBookingId,
      remark: booking.remark ?? "",
      dateFrom: resolvedDateFrom,
      dateTo: newDateTo,
      reservedForUsers,
      reservedForEmails,
      site: user?.site ?? "",
      description: booking.description,
      project: booking.project ?? "",
      redPandaProjects,
      force: false,
      hazardousDeclaration,
      assistanceDeclaration,
      elnId,
    },
    newDateTo,
  };
};
